<template>
  <keep-alive>
    <div style="height: 100vh;" v-loading="store.loading">
      <router-view />
    </div>
  </keep-alive>

</template>

<script setup>
import { useStore } from '@/store/index';
const store = useStore();

defineOptions({
  name: 'App'
});
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
